import React from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import RefreshIcon from "@mui/icons-material/Cached";

const ConnectivityProviderContext = React.createContext({
  connected: false,
  getConnectionStatus: () => { }
});

function TransitionDown(props) {
  return <Slide {...props} direction="right" />;
}

const ConnectivityProvider = ({ children }) => {
  const [_connected, _setConnected] = React.useState(navigator.onLine);

  const getConnectionStatus = async () => {
    try{
      await fetch(process.env.REACT_APP_API_URL, { method: "get", mode: "no-cors" });
      console.debug("NETWORK_STATUS::ONLINE");
      _setConnected(true);
      return true;
    }catch(e){
      console.debug("NETWORK_STATUS::OFFLINE");
      console.error(JSON.stringify(e));
      _setConnected(false);
      return false;
    }
  }

  React.useEffect(() => {
    if (navigator.connection)
      navigator.connection.addEventListener("change", getConnectionStatus);

    return () =>
      navigator?.connection?.removeEventListener("change", getConnectionStatus);
  }, []);

  React.useEffect(() => {
    window.addEventListener("online", getConnectionStatus);

    return () => window.removeEventListener("online", getConnectionStatus);
  }, []);

  React.useEffect(() => {
    window.addEventListener("offline", getConnectionStatus);

    return () => window.removeEventListener("offline", getConnectionStatus);
  }, []);

  return (
    <ConnectivityProviderContext.Provider
      value={{
        connected: _connected,
        getConnectionStatus: getConnectionStatus
      }}
    >
      <Snackbar
        open={false}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={TransitionDown}
        transitionDuration={{ enter: 200, exit: 1000 }}
      >
        <Alert
          severity={_connected ? "success" : "error"}
          sx={{ width: "100%" }}
          action={_connected ? null : (
            <Button
              color="primary"
              size="small"
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={getConnectionStatus}
            >
              Check Now
            </Button>
          )}
        >
          <AlertTitle>No Connection</AlertTitle>
          You are not connected to Internet!
        </Alert>
      </Snackbar>
      {children}
    </ConnectivityProviderContext.Provider>
  );
};

const useConnected = () => {
  const { connected, getConnectionStatus } = React.useContext(ConnectivityProviderContext);

  return { connected, getConnectionStatus };
};

export { ConnectivityProviderContext, ConnectivityProvider, useConnected };